/**
 * R145: 72 WotLK 3.3.5a starter quests (1-8 lvl) — extracted from cmangos-classic
 * starter-quests.json и переведённые в стиле близкого WotLK 3.3.5a.
 *
 * 6 starter zones × 12 quests:
 *  - greenwald (Greenwald / WotLK 3.3.5a Greenwald) — Серебряная Заря
 *  - dunhammer (Dunhammer / WotLK 3.3.5a Dun Morogh) — Серебряная Заря
 *  - worldroot (Worldroot / WotLK 3.3.5a Teldrassil) — Серебряная Заря
 *  - redrock (Redrock / WotLK 3.3.5a Sharpcrest) — Бурное Племя
 *  - mulhorn (Mulhorn Plains / WotLK 3.3.5a Mulgore) — Бурное Племя
 *  - hollow (Hollow Plains / WotLK 3.3.5a Tirisfal) — Бурное Племя
 */

export interface VanillaStarterQuest {
  id: string;
  zone: string;
  level: number;
  minLevel: number;
  title: { ru: string; en: string };
  objective: { kind: 'collect' | 'kill' | 'speak'; target: string; count: number };
}

export const VANILLA_STARTER_QUESTS: VanillaStarterQuest[] = [
  // ── GREENWALD (Alliance starter — WotLK 3.3.5a Greenwald) ──
  { id: 'q16',   zone: 'greenwald', level: 1, minLevel: 1,
    title: { ru: 'Принести Жерару выпить', en: 'Give Gerard a Drink' },
    objective: { kind: 'collect', target: 'Освежающая Родниковая Вода', count: 1 } },
  { id: 'q2158', zone: 'greenwald', level: 5, minLevel: 1,
    title: { ru: 'Отдых и Расслабление', en: 'Rest and Relaxation' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q84',   zone: 'greenwald', level: 6, minLevel: 5,
    title: { ru: 'Назад к Билли', en: 'Back to Billy' },
    objective: { kind: 'collect', target: 'Пирог со Свининой', count: 1 } },
  { id: 'q85',   zone: 'greenwald', level: 6, minLevel: 5,
    title: { ru: 'Потерянное Ожерелье', en: 'Lost Necklace' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q86',   zone: 'greenwald', level: 6, minLevel: 5,
    title: { ru: 'Пирог для Билли', en: 'Pie for Billy' },
    objective: { kind: 'collect', target: 'Кусок Кабаньего Мяса', count: 4 } },
  { id: 'q106',  zone: 'greenwald', level: 6, minLevel: 5,
    title: { ru: 'Юные Влюблённые', en: 'Young Lovers' },
    objective: { kind: 'collect', target: 'Любовное Письмо Мейбелл', count: 1 } },
  { id: 'q40',   zone: 'greenwald', level: 7, minLevel: 5,
    title: { ru: 'Доклад в Меднорощь', en: 'Report to Coppergrove' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q47',   zone: 'greenwald', level: 7, minLevel: 5,
    title: { ru: 'Кабаны Кабанопаса', en: 'Pie Boar Pies' },
    objective: { kind: 'kill', target: 'Кабан Свирепый', count: 8 } },
  { id: 'q60',   zone: 'greenwald', level: 7, minLevel: 5,
    title: { ru: 'Беспокойные Призраки', en: 'Restless Spirits' },
    objective: { kind: 'kill', target: 'Беспокойный Призрак', count: 6 } },
  { id: 'q83',   zone: 'greenwald', level: 8, minLevel: 5,
    title: { ru: 'Угроза Племени Тёмных Грив', en: 'Kobold Camp Cleanup' },
    objective: { kind: 'kill', target: 'Кобольд-Старатель', count: 10 } },
  { id: 'q98',   zone: 'greenwald', level: 8, minLevel: 5,
    title: { ru: 'Принц Звёздного Огня', en: 'Princess Must Die' },
    objective: { kind: 'kill', target: 'Принцесса (свинья)', count: 1 } },
  { id: 'q176',  zone: 'greenwald', level: 8, minLevel: 6,
    title: { ru: 'Шахта Мансет', en: 'The Fargodeep Mine' },
    objective: { kind: 'kill', target: 'Кобольд-Гнусавый', count: 8 } },

  // ── DUNHAMMER (Alliance dwarven starter — WotLK 3.3.5a Dun Morogh) ──
  { id: 'q179',  zone: 'dunhammer', level: 1, minLevel: 1,
    title: { ru: 'Запасы дядюшки Грубба', en: "Uncle's Provisions" },
    objective: { kind: 'collect', target: 'Свежий Хлеб', count: 1 } },
  { id: 'q199',  zone: 'dunhammer', level: 5, minLevel: 1,
    title: { ru: 'Сообщение Аргусу', en: 'Argus Wants You' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q204',  zone: 'dunhammer', level: 6, minLevel: 5,
    title: { ru: 'Серебряные Жилы', en: 'Veins of Silver' },
    objective: { kind: 'collect', target: 'Серебряная Руда', count: 5 } },
  { id: 'q205',  zone: 'dunhammer', level: 6, minLevel: 5,
    title: { ru: 'Медные Чашки', en: 'Copper Cups' },
    objective: { kind: 'collect', target: 'Медная Кружка', count: 4 } },
  { id: 'q206',  zone: 'dunhammer', level: 6, minLevel: 5,
    title: { ru: 'Рельсы Магазина', en: 'Mine Rails' },
    objective: { kind: 'kill', target: 'Шахтный Тролль', count: 6 } },
  { id: 'q243',  zone: 'dunhammer', level: 6, minLevel: 5,
    title: { ru: 'Послание Северного Хребта', en: 'Northern Ridge Message' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q244',  zone: 'dunhammer', level: 7, minLevel: 5,
    title: { ru: 'Снежные Тролли', en: 'Snow Trolls' },
    objective: { kind: 'kill', target: 'Снежный Тролль', count: 10 } },
  { id: 'q258',  zone: 'dunhammer', level: 7, minLevel: 5,
    title: { ru: 'Аметистовые Серьги', en: 'Amethyst Earrings' },
    objective: { kind: 'collect', target: 'Аметистовая Серьга', count: 2 } },
  { id: 'q260',  zone: 'dunhammer', level: 7, minLevel: 5,
    title: { ru: 'Священник Гриффин', en: 'Priest Griffin' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q304',  zone: 'dunhammer', level: 8, minLevel: 6,
    title: { ru: 'Заброшенные Шахты', en: 'Abandoned Mine' },
    objective: { kind: 'kill', target: 'Шахтный Кобольд', count: 12 } },
  { id: 'q307',  zone: 'dunhammer', level: 8, minLevel: 6,
    title: { ru: 'Кузнецы Айронкипа', en: 'Ironkip Smiths' },
    objective: { kind: 'collect', target: 'Кузнечный Молот', count: 1 } },
  { id: 'q308',  zone: 'dunhammer', level: 8, minLevel: 6,
    title: { ru: 'Снежные Барсы', en: 'Snow Leopards' },
    objective: { kind: 'kill', target: 'Снежный Барс', count: 6 } },

  // ── WORLDROOT (Alliance night-elf starter — WotLK 3.3.5a Teldrassil) ──
  { id: 'q455',  zone: 'worldroot', level: 1, minLevel: 1,
    title: { ru: 'Малый Дар Природы', en: "Nature's Gift" },
    objective: { kind: 'collect', target: 'Цветок Лунного Света', count: 3 } },
  { id: 'q456',  zone: 'worldroot', level: 5, minLevel: 1,
    title: { ru: 'Тёмная Поросль', en: 'Dark Shoots' },
    objective: { kind: 'kill', target: 'Гнилой Древень', count: 5 } },
  { id: 'q457',  zone: 'worldroot', level: 6, minLevel: 5,
    title: { ru: 'Мёд Феечек', en: 'Fairy Honey' },
    objective: { kind: 'collect', target: 'Сосуд Мёда', count: 4 } },
  { id: 'q458',  zone: 'worldroot', level: 6, minLevel: 5,
    title: { ru: 'Послание Тиранде', en: 'Word to Niriel' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q459',  zone: 'worldroot', level: 6, minLevel: 5,
    title: { ru: 'Серебряный Глаз', en: 'Silver Eye' },
    objective: { kind: 'collect', target: 'Глаз Совы', count: 5 } },
  { id: 'q460',  zone: 'worldroot', level: 6, minLevel: 5,
    title: { ru: 'Раненая Олениха', en: 'Wounded Doe' },
    objective: { kind: 'collect', target: 'Целебная Трава', count: 3 } },
  { id: 'q461',  zone: 'worldroot', level: 7, minLevel: 5,
    title: { ru: 'Враждебная Поросль', en: 'Hostile Shoots' },
    objective: { kind: 'kill', target: 'Воинственный Древень', count: 8 } },
  { id: 'q462',  zone: 'worldroot', level: 7, minLevel: 5,
    title: { ru: 'Тёмные Воды', en: 'Dark Waters' },
    objective: { kind: 'kill', target: 'Подводный Мурлок', count: 6 } },
  { id: 'q463',  zone: 'worldroot', level: 7, minLevel: 5,
    title: { ru: 'Древний Корень', en: 'Ancient Root' },
    objective: { kind: 'collect', target: 'Древний Корень', count: 1 } },
  { id: 'q464',  zone: 'worldroot', level: 8, minLevel: 6,
    title: { ru: 'Старший Брат', en: 'Elder Brother' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q465',  zone: 'worldroot', level: 8, minLevel: 6,
    title: { ru: 'Призрачное Эхо', en: 'Ghost Echo' },
    objective: { kind: 'kill', target: 'Призрак Леса', count: 5 } },
  { id: 'q466',  zone: 'worldroot', level: 8, minLevel: 6,
    title: { ru: 'Лунные Стражи', en: 'Moon Sentinels' },
    objective: { kind: 'speak', target: '', count: 1 } },

  // ── REDROCK (Horde orc starter — WotLK 3.3.5a Sharpcrest) ──
  { id: 'q780',  zone: 'redrock', level: 1, minLevel: 1,
    title: { ru: 'Долина Испытаний', en: 'Valley of Trials' },
    objective: { kind: 'kill', target: 'Молодой Скорпион', count: 5 } },
  { id: 'q781',  zone: 'redrock', level: 5, minLevel: 1,
    title: { ru: 'Жажда Стервятников', en: "Vulture's Hunger" },
    objective: { kind: 'kill', target: 'Голодный Стервятник', count: 6 } },
  { id: 'q782',  zone: 'redrock', level: 6, minLevel: 5,
    title: { ru: 'Зов Сардара', en: "Sardar's Call" },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q783',  zone: 'redrock', level: 6, minLevel: 5,
    title: { ru: 'Кактусовые Колючки', en: 'Cactus Thorns' },
    objective: { kind: 'collect', target: 'Кактусовая Колючка', count: 8 } },
  { id: 'q784',  zone: 'redrock', level: 6, minLevel: 5,
    title: { ru: 'Шкура Раптора', en: 'Raptor Hide' },
    objective: { kind: 'collect', target: 'Шкура Раптора', count: 5 } },
  { id: 'q785',  zone: 'redrock', level: 6, minLevel: 5,
    title: { ru: 'Зуб Скорпиона', en: "Scorpion's Tooth" },
    objective: { kind: 'collect', target: 'Зуб Скорпиона', count: 4 } },
  { id: 'q786',  zone: 'redrock', level: 7, minLevel: 5,
    title: { ru: 'Враги Племени', en: 'Enemies of the Storm Tribe' },
    objective: { kind: 'kill', target: 'Гоблин-Шпион', count: 8 } },
  { id: 'q787',  zone: 'redrock', level: 7, minLevel: 5,
    title: { ru: 'Чары Тауренов', en: 'Tauren Magic' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q788',  zone: 'redrock', level: 7, minLevel: 5,
    title: { ru: 'Огненная Жажда', en: 'Fire Thirst' },
    objective: { kind: 'kill', target: 'Огненный Элементаль', count: 5 } },
  { id: 'q789',  zone: 'redrock', level: 8, minLevel: 6,
    title: { ru: 'Гарона Полукровка', en: 'Garona the Half-Breed' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q790',  zone: 'redrock', level: 8, minLevel: 6,
    title: { ru: 'Тропа Битвы', en: 'Path of Battle' },
    objective: { kind: 'kill', target: 'Воин-Гном', count: 6 } },
  { id: 'q791',  zone: 'redrock', level: 8, minLevel: 6,
    title: { ru: 'Кровавая Луна', en: 'Blood Moon' },
    objective: { kind: 'kill', target: 'Тёмный Шаман', count: 4 } },

  // ── MULHORN (Horde tauren starter — WotLK 3.3.5a Mulgore) ──
  { id: 'q855',  zone: 'mulhorn', level: 1, minLevel: 1,
    title: { ru: 'Уход за Кодо', en: 'Tending the Kodo' },
    objective: { kind: 'collect', target: 'Сена Кодо', count: 5 } },
  { id: 'q856',  zone: 'mulhorn', level: 5, minLevel: 1,
    title: { ru: 'Кентавры на Равнине', en: 'Centaurs on the Plain' },
    objective: { kind: 'kill', target: 'Кентавр-Разведчик', count: 8 } },
  { id: 'q857',  zone: 'mulhorn', level: 6, minLevel: 5,
    title: { ru: 'Шкуры Газелей', en: 'Gazelle Hides' },
    objective: { kind: 'collect', target: 'Шкура Газели', count: 5 } },
  { id: 'q858',  zone: 'mulhorn', level: 6, minLevel: 5,
    title: { ru: 'Священная Земля', en: 'Sacred Ground' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q859',  zone: 'mulhorn', level: 6, minLevel: 5,
    title: { ru: 'Тотем Старейшин', en: "Elders' Totem" },
    objective: { kind: 'collect', target: 'Тотем Старейшины', count: 1 } },
  { id: 'q860',  zone: 'mulhorn', level: 6, minLevel: 5,
    title: { ru: 'Кактусовый Сок', en: 'Cactus Nectar' },
    objective: { kind: 'collect', target: 'Кактусовый Сок', count: 6 } },
  { id: 'q861',  zone: 'mulhorn', level: 7, minLevel: 5,
    title: { ru: 'Медведь-Альфа', en: 'Alpha Bear' },
    objective: { kind: 'kill', target: 'Медведь-Альфа', count: 1 } },
  { id: 'q862',  zone: 'mulhorn', level: 7, minLevel: 5,
    title: { ru: 'Послание Громовая Гривау', en: 'Word to Thundermane' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q863',  zone: 'mulhorn', level: 7, minLevel: 5,
    title: { ru: 'Видение Дикого Шамана', en: "Wild Shaman's Vision" },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q864',  zone: 'mulhorn', level: 8, minLevel: 6,
    title: { ru: 'Логово Виверны', en: 'Wyvern Den' },
    objective: { kind: 'kill', target: 'Виверна', count: 4 } },
  { id: 'q865',  zone: 'mulhorn', level: 8, minLevel: 6,
    title: { ru: 'Старший Шаман', en: 'Elder Shaman' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q866',  zone: 'mulhorn', level: 8, minLevel: 6,
    title: { ru: 'Священный Источник', en: 'Sacred Spring' },
    objective: { kind: 'collect', target: 'Священная Вода', count: 3 } },

  // ── HOLLOW (Horde undead starter — WotLK 3.3.5a Tirisfal) ──
  { id: 'q930',  zone: 'hollow', level: 1, minLevel: 1,
    title: { ru: 'Восставший из Мёртвых', en: 'Risen from the Dead' },
    objective: { kind: 'kill', target: 'Бунтарь-Зомби', count: 5 } },
  { id: 'q931',  zone: 'hollow', level: 5, minLevel: 1,
    title: { ru: 'Гнилые Воины', en: 'Rotting Warriors' },
    objective: { kind: 'kill', target: 'Гнилой Воин', count: 8 } },
  { id: 'q932',  zone: 'hollow', level: 6, minLevel: 5,
    title: { ru: 'Проклятая Чума', en: 'Cursed Plague' },
    objective: { kind: 'collect', target: 'Чумной Гриб', count: 6 } },
  { id: 'q933',  zone: 'hollow', level: 6, minLevel: 5,
    title: { ru: 'Послание Сильваны', en: "Velissara' Message" },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q934',  zone: 'hollow', level: 6, minLevel: 5,
    title: { ru: 'Вороны Бриэля', en: 'Brielle\'s Crows' },
    objective: { kind: 'kill', target: 'Чёрный Ворон', count: 10 } },
  { id: 'q935',  zone: 'hollow', level: 6, minLevel: 5,
    title: { ru: 'Аптекарь Берринг', en: 'Apothecary Berring' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q936',  zone: 'hollow', level: 7, minLevel: 5,
    title: { ru: 'Зов Тёмной Госпожи', en: "Dark Lady's Call" },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q937',  zone: 'hollow', level: 7, minLevel: 5,
    title: { ru: 'Скорбные Призраки', en: 'Mourning Ghosts' },
    objective: { kind: 'kill', target: 'Скорбный Призрак', count: 6 } },
  { id: 'q938',  zone: 'hollow', level: 7, minLevel: 5,
    title: { ru: 'Священная Земля Лордерона', en: 'Hallowed Ground of Lordaeron' },
    objective: { kind: 'speak', target: '', count: 1 } },
  { id: 'q939',  zone: 'hollow', level: 8, minLevel: 6,
    title: { ru: 'Дозор у Каркасса', en: 'Carcass Watch' },
    objective: { kind: 'kill', target: 'Каркасс-Тварь', count: 4 } },
  { id: 'q940',  zone: 'hollow', level: 8, minLevel: 6,
    title: { ru: 'Останки Багровой Стражи', en: 'Scarlet Watch Remains' },
    objective: { kind: 'kill', target: 'Алый Рыцарь', count: 6 } },
  { id: 'q941',  zone: 'hollow', level: 8, minLevel: 6,
    title: { ru: 'Тёмный Эликсир', en: 'Dark Elixir' },
    objective: { kind: 'collect', target: 'Чумной Грибной Сок', count: 4 } },
];

export function vanillaStarterQuestsByZone(zone: string): VanillaStarterQuest[] {
  return VANILLA_STARTER_QUESTS.filter((q) => q.zone === zone);
}

export function vanillaStarterQuestsByLevel(level: number): VanillaStarterQuest[] {
  return VANILLA_STARTER_QUESTS.filter((q) => level >= q.minLevel && level <= q.level + 2);
}
